<template>
    <div class="page-footer">
        <span class="page-footer-inner">{{ new Date().getFullYear() }} &copy; {{$t('Kipaki charity dashboard | version 1.0')}}<span> | </span><a href="javascript:void(0);" @click="showPrivacyPolicy">{{ $t('Privacy Policy') }}</a></span> 
        
        <color-themes></color-themes>
    </div>
</template>

<script>
    import colorThemes from "../Widgets/color-themes/color-themes";
    export default {
        components: {
            "color-themes": colorThemes
        },
        methods: {
            showPrivacyPolicy() {
                serverBus.$emit('showPrivacyPopup', true);
                // request({
                //     url: "general-information",
                //     method: "GET"
                // }).then(response => {
                //     this.privacy_policy = response.data.data.privacy_policy;
                //     this.visible = true;
                // });
            }
        },
        data() {
            return {
                
            }
        }
    }

</script>

<style lang="scss">
    .page-footer-inner {
        color: #626262;
        color:var(--base-text-color);
        line-height: 50px;
        float: left;
        text-transform: capitalize;
        font-size: 87.5%;
    }
    .color-palete{
        float: right;
        position: relative;
        width: 8%;
    }
    @media only screen and (max-width: 1024px) {
        .color-palete{
            width: 12%;
        }
    }
    @media only screen and (max-width: 768px) {
        .color-palete{
            width: 20%;
        }
    }
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) { /* ie10, ie11+ */
        .color-palete{
            display: none;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Layout/BottomFooter/BottomFooter.vue